import React from 'react';

export default class CCLearnerRegistration extends React.Component {
  render() {
    return null;
  }
}
